import React, { useEffect, useState } from 'react';
import { supabase } from '../config';

export default function Debug() {
  const [logs, setLogs] = useState([]);
  const [timings, setTimings] = useState({});

  useEffect(() => {
    const run = async () => {
      console.time("TOTAL");
      const newLogs = [];
      const newTimings = {};

      // STEP 1: Get Session
      console.time("STEP 1");
      const session = await supabase.auth.getSession();
      console.timeEnd("STEP 1");
      newLogs.push('STEP 1: getSession() executed');
      newTimings['STEP 1'] = 'See console';

      // STEP 2: Check all main tables
      console.time("STEP 2");
      const tables = [
        'users',
        'participants',
        'races',
        'events',
        'organizers',
        'prices',
        'requirements',
        'options',
        'registrations',
        'tickets',
        'tracks',
      ];

      const tableResults = {};
      for (const table of tables) {
        try {
          console.time(`Table: ${table}`);
          const { data, error } = await supabase.from(table).select("*").limit(1);
          console.timeEnd(`Table: ${table}`);
          
          if (error) {
            tableResults[table] = `Error: ${error.message}`;
          } else {
            tableResults[table] = `Found (${data?.length || 0} row${data?.length !== 1 ? 's' : ''})`;
          }
        } catch (err) {
          tableResults[table] = `Exception: ${err.message}`;
        }
      }
      console.timeEnd("STEP 2");

      // Format logs
      newLogs.push('');
      newLogs.push('STEP 2: Table Status');
      newLogs.push('─'.repeat(40));
      Object.entries(tableResults).forEach(([table, status]) => {
        newLogs.push(`${table.padEnd(20)} ${status}`);
      });

      console.timeEnd("TOTAL");
      newLogs.push('');
      newLogs.push('Timing information available in browser console (F12)');

      setLogs(newLogs);
    };

    run();
  }, []);

  return (
    <div style={{ padding: '20px', backgroundColor: '#f9fafb', minHeight: '100vh' }}>
      <h1>Debug Page - Database Connectivity</h1>
      <p>Checking Supabase connection and table status...</p>
      
      <div style={{ 
        backgroundColor: '#fff', 
        padding: '15px', 
        borderRadius: '8px', 
        border: '1px solid #e5e7eb',
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        fontSize: '13px',
        lineHeight: '1.6'
      }}>
        {logs.length === 0 ? (
          <p>Loading...</p>
        ) : (
          logs.map((log, index) => (
            <div key={index} style={{ margin: '2px 0' }}>
              {log}
            </div>
          ))
        )}
      </div>

      <p style={{ marginTop: '20px', fontSize: '12px', color: '#6b7280' }}>
        Open browser console (F12) for detailed timing information
      </p>
    </div>
  );
}
